export const PasswordRegex = new RegExp("^(?=.*[a-z])(?=.*\\d)");
export const EmailRegex = (/^[a-zA-Z0-9-_.]+@[a-zA-Z0-9]+\.[A-Za-z]+$/);
export const EnglishRegex = (/^[a-zA-Z0-9 -_.&]+$/)
export const NameRegex = (/^[a-zA-Z ]+$/)